import React from 'react';
import HeroSection from '../components/HeroSection';
import FeaturesSection from '../components/FeaturesSection';
import HowItWorks from '../components/HowItWorks';
import ComparisonTable from '../components/ComparisonTable';
import WhoWeHelp from '../components/WhoWeHelp';
import CaseStudies from '../components/CaseStudies';
import TestimonialsSection from '../components/TestimonialsSection';
import FAQSection from '../components/FAQSection';
import SchedulingSection from '../components/SchedulingSection';
import WelcomeVideo from '../components/WelcomeVideo';
import PricingSection from '../components/PricingSection';
import Footer from '../components/Footer';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-white font-inter">
      <main>
        <HeroSection />
        <WelcomeVideo />
        <FeaturesSection />
        <HowItWorks />
        <ComparisonTable />
        <WhoWeHelp />
        <CaseStudies />
        <PricingSection />
        <TestimonialsSection />
        <FAQSection />
        <SchedulingSection />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;